// extracted by mini-css-extract-plugin
export default {"miComplianceLinksWrapper":"compliance-links_miComplianceLinksWrapper__typDZ"};